<!--带有分页逻辑的table-->
<template>
  <div class="vm-page-table">
    <div v-if="$slots.adSearch" ref="adSearch" class="ad-search">
      <div :id="'vm-search-' + _uid" class="ad-search_content">
        <slot name="adSearch"/>
        <div class="ad-search-btn">
          <el-button
              v-if="showExport"
              :loading="exportLoading"
              type="success"
              size="mini"
              style="height: 26px; padding: 0 8px"
              @click="handleExport">
            导出
          </el-button>
          <el-button type="primary" size="mini" @click="handleSearchClick"> 查询 </el-button>
          <el-button
              v-if="!hideClear"
              plain
              type="primary"
              size="mini"
              @click="handleClearClick">
            重置
          </el-button>
          <span v-if="searchMoreShow">
            <a v-if="!searchShow" class="actionDown" @click="toggleMoreSearch">
              展开
              <i class="el-icon-arrow-down"/>
            </a>
            <a v-if="searchShow" class="actionDown" @click="toggleMoreSearch">
              收起
              <i class="el-icon-arrow-up"/>
            </a>
          </span>
        </div>
      </div>
    </div>
    <div v-if="columnsBtnShow" style="position: relative; margin-bottom: 5px; height: 28px">
      <div v-if="$slots.toolbar" class="tools-bar">
        <slot name="toolbar"/>
      </div>
      <div class="colsAction">
        <div class="acticonBtn" @click="open">
          <i class="el-icon-setting"/>
        </div>
      </div>
    </div>
    <!-- 列显示dialog -->
    <el-dialog
        v-el-drag-dialog
        append-to-body
        title="选择表头显示内容"
        :visible.sync="dialogVisible"
        width="800px">
      <div style="display: flex">
        <div class="dialogLeft">
          <el-checkbox v-model="allCheck" style="width: 120px; margin-top: 10px" @change="allCheckHandle">全选</el-checkbox>
          <br>
          <el-checkbox
              v-for="(item, index) in checkBoxArr"
              :key="item.id"
              :value="item.checked"
              style="width: 120px; margin-top: 10px"
              @change="checkListChange(index)">
            <vm-table-column-label :column="item"/>
          </el-checkbox>
        </div>
        <div id="dialogRight">
          <div v-for="item in rightContent" :key="item.id" :class="item.filterItem" class="item">
            <i class="el-icon-rank" style="margin-right: 5px"/>
            <vm-table-column-label v-if="!item.label" :column="item"/>
            <span v-else>{{item.label}}</span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="float: left" @click="reset">恢复默认设置</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureHandle">确 定</el-button>
      </span>
    </el-dialog>
    <div class="wrapper">
      <el-table
          v-if="tableShow"
          ref="elTable"
          v-loading="status === 'loading' && tableData.length > 0"
          v-bind="$attrs"
          stripe
          :data="tableData"
          :max-height="myMaxHeight"
          border
          v-on="$listeners">
        >
        <template slot="empty">
          <i v-if="status === 'loading'" class="el-icon-loading" style="font-size: 18px"/>
          <el-button v-else-if="status === 'error'" @click="handleSearchClick"> 加载失败，点击重新获取 </el-button>
          <div v-else-if="status === 'empty'">暂无数据</div>
        </template>
        <slot/>
      </el-table>
      <div v-if="!noPage" style="margin-top: 16px; overflow: hidden">
        <el-pagination
            class="page"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"/>
      </div>
    </div>
  </div>
</template>

<script>
  import Sortable from "sortablejs";
  import VmTableColumnLabel from "@/components/VmTableColumnLabel.vue";
  /*查询条件filter必须使用:filter.sync="filter"传递*/
  export default {
    components: {
      VmTableColumnLabel,
    },
    props: {
      module: {
        type: String,
        required: true,
      },
      url: {
        type: String,
        required: true,
      },
      filter: {
        type: Object,
      },
      //是否显示导出按钮
      showExport: {
        type: Boolean,
        default: false,
      },
      //导出按钮加载
      exportLoading: {
        type: Boolean,
        default: false,
      },
      //是否显示清空按钮
      hideClear: {
        type: Boolean,
        default: false,
      },
      //是否有分页
      noPage: {
        type: Boolean,
        default: false,
      },
      // 表格是否设置最大高度
      isHeight: {
        type: Boolean,
        default: true,
      },
      searchMoreShow: {
        type: Boolean,
        default: false,
      },
      // 是否显示列设置按钮
      columnsBtnShow: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        allCheck: true,
        tableShow: true,
        searchShow: false,
        status: "loading", //loading error empty
        currentPage: 1,
        total: 0,
        pageSize: 10,
        tableData: [],
        //保存一份filter的原始拷贝，用于重置条件
        filterCopy: JSON.stringify(this.filter),
        currentRowIndex: 0,
        checkBoxArr: [],
        dialogVisible: false,
        rightContent: [],
        myMaxHeight: -1,
      };
    },
    mounted() {
      // 初始化表格最大高度
      this.setMaxHeight();
      // 切换窗口大小计算表格最大高度
      window.onresize = () => {
        this.setMaxHeight();
      };
      //为所有input框添加enter键搜索事件
      let searchBox = document.getElementById("vm-search-" + this._uid);
      if (searchBox) {
        let controls = searchBox.getElementsByTagName("input");
        for (let item of controls) {
          item.onkeydown = (event) => {
            if (event.key === "Enter") {
              this.getList(1);
            }
          };
        }
      }

      // 查询用户是否设置列显示信息
      this.$http.get("basic", `userHabits?code=${this.url}`).then((res) => {
        this.$refs.elTable.store.states.columns.forEach((item) => {
          this.checkBoxArr.push(item);
        });
        this.checkBoxArr.forEach((item) => {
          if (!item.label || item.label === "操作" || item.label === "#") {
            item.filterItem = "filtered";
          }
          if (["selection", "radio"].includes(item.type)) {
            item.label = "选择";
          }
        });
        // 没有设置过
        if (!res.data) {
          this.allCheck = true;
          this.checkBoxArr.forEach((item) => {
            item.checked = true;
            this.rightContent.push(item);
          });
        } else {
          let arr = JSON.parse(res.data.description);
          console.log(arr);
          let newArr = [];
          arr.forEach((i) => {
            this.$refs.elTable.store.states.columns.forEach((item) => {
              if (item.property === i) {
                newArr.push(item);
              }
            });
          });
          this.checkBoxArr.forEach((item) => {
            arr.forEach((i) => {
              if (item.property === i) {
                item.checked = true;
              }
            });
          });
          if (arr.length === this.checkBoxArr.length) {
            this.allCheck = true;
          } else {
            this.allCheck = false;
          }
          this.rightContent = newArr;
          this.$refs.elTable.store.states.columns = newArr;
          this.$refs.elTable.store.updateColumns();
          console.log(this.$refs.elTable.store);
        }
      });
    },

    methods: {
      // 列设置模态框
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.rowDrop();
        });
      },

      // 重置
      reset() {
        this.checkBoxArr.forEach((item) => {
          item.checked = true;
        });
        this.allCheck = true;
        this.rightContent = this.checkBoxArr.filter((item) => item.checked);
      },
      // 确定
      sureHandle() {
        if (!this.rightContent.length) {
          this.$message.error("至少选择一列显示");
          return;
        }
        this.tableShow = false;
        this.dialogVisible = false;
        let labelArr = [];
        let newArr = [];
        this.rightContent.forEach((item) => {
          labelArr.push(item.property);
          newArr.push(item);
        });
        const params = {
          code: this.url,
          description: JSON.stringify(labelArr),
        };
        console.log(params);
        this.$http.post("basic", "userHabits", params).then((res) => {
          if (res.success) {
            this.tableShow = true;
            this.$message.success("设置成功");
            this.$nextTick(() => {
              this.$refs.elTable.store.states._columns = newArr;
              this.rightContent = newArr;
              this.$refs.elTable.store.updateColumns();
            });
          }
        });
      },
      // 全选
      allCheckHandle(value) {
        this.checkBoxArr.forEach((item) => {
          item.checked = value;
        });
        this.rightContent = this.checkBoxArr.filter((item) => item.checked);
      },

      checkListChange(index) {
        this.checkBoxArr.forEach((item, i) => {
          if (i === index) {
            item.checked = !item.checked;
          }
        });
        const arr = this.checkBoxArr.filter((item) => !item.checked);
        if (arr.length === 0) {
          this.allCheck = true;
        } else {
          this.allCheck = false;
        }
        this.rightContent = this.checkBoxArr.filter((item) => item.checked);
      },

      // 拖动
      rowDrop() {
        let that = this;
        // eslint-disable-next-line no-unused-vars
        let sortable = new Sortable(document.getElementById("dialogRight"), {
          sort: true,
          animation: 150,
          chosenClass: "sortable-drag",
          dragClass: "sortable-drag",
          direction: "horizontal",
          filter: ".filtered",
          onEnd: function(evt) {
            that.rightContent.splice(evt.newIndex, 0, that.rightContent.splice(evt.oldIndex, 1)[0]);
            let newArray = that.rightContent.slice(0);
            that.rightContent = [];
            that.$nextTick(function() {
              that.rightContent = newArray;
            });
          },
        });
      },

      // 展开搜索条件
      toggleMoreSearch() {
        this.searchShow = !this.searchShow;
        this.$emit("searchShow", this.searchShow);
      },

      getList(pageNum) {
        if (this.noPage) {
          this.getListNoPage();
        } else {
          this.getListWithPage(pageNum);
        }
      },

      //等于-1表示获取当前页
      getListWithPage(pageNum) {
        this.status = "loading";
        if (pageNum > 0) {
          this.currentPage = pageNum;
        }
        let params = Object.assign({ pageSize: this.pageSize, pageNum: this.currentPage }, this.filter);
        let config = {
          url: this.url,
          method: this.method,
        };
        if (this.method === "post") {
          config.data = params;
        } else {
          config.params = params;
        }
        this.$http
          .request(this.module, config)
          .then((res) => {
            if (res.success) {
              this.tableData = res.data.records;
              this.total = res.data.total;
              if (this.total === 0) {
                this.status = "empty";
              } else {
                this.status = "finish";
                this.$emit("setSelectedRow", this.tableData[0]);
              }
            }
          })
          .catch(() => {
            this.status = "error";
          });
      },

      getListNoPage() {
        this.status = "loading";
        let config = {
          url: this.url,
          method: this.method,
        };
        if (this.method === "post") {
          config.data = this.filter;
        } else {
          config.params = this.filter;
        }
        this.$http
          .request(this.module, config)
          .then((data) => {
            this.tableData = data;
            if (!data || data.length === 0) {
              this.status = "empty";
            } else {
              this.status = "finish";
            }
          })
          .catch(() => {
            this.status = "error";
          });
      },

      handleCurrentChange(pageNum) {
        this.getList(pageNum);
      },

      handleSearchClick() {
        this.getList(1);
      },

      handleExport() {
        this.$emit("export");
      },

      handleClearClick() {
        this.$emit("update:filter", JSON.parse(this.filterCopy));
        this.$nextTick(() => {
          this.getList(1);
        });
      },
      // 切换分页显示的条数
      handleSizeChange(val) {
        this.pageSize = val;
        this.currentPage = 1;
        this.getListWithPage(1);
      },

      // 动态设置表格最大高度
      setMaxHeight() {
        if (this.isHeight) {
          let bar = document.getElementsByClassName("ad-search");
          let toolbar = document.getElementsByClassName("tools-bar");
          let clientHeight = document.body.clientHeight;
          if (bar.length) {
            this.barHeight = bar[0].offsetHeight;
          } else {
            this.barHeight = 0;
          }
          if (toolbar.length) {
            this.toolBarHeight = toolbar[0].offsetHeight;
          } else {
            this.toolBarHeight = 0;
          }
          this.myMaxHeight = clientHeight - this.barHeight - this.toolBarHeight - 172;
          if (this.$refs.elTable) {
            this.$nextTick(() => {
              this.$refs.elTable.$el.style["max-height"] = this.myMaxHeight + "px";
            });
          }
        }
      },
    },
  };
</script>

<style lang="scss">
.vm-page-table {
  .ad-search {
    overflow: auto;
    width: auto;
    border: 1px solid #ebeef5;
    margin-bottom: 5px;
    background-color: #f4f7fa;
    .ad-search_content {
      position: relative;
      display: inline-block;
      width: 100%;
      padding-top: 5px;
      .ad-search-btn {
        float: left;
        margin: 2px 0 0 5px;
      }
    }
  }

  .page {
    float: right;
  }

  .el-loading-spinner {
    position: fixed;
    width: 100px;
    top: 50%;
    left: 50%;
  }

  // 新增样式
  .el-table--border .el-table__cell:first-child .cell {
    padding-right: 10px;
  }

  .el-radio__label {
    padding-left: 0;
  }

  .el-radio__label {
    display: none;
  }

  .actionDown {
    margin-left: 8px;
    font-weight: 700;
    &:hover {
      text-decoration: none;
    }

    i {
      font-weight: 700;
    }
  }
  .el-table {
    width: 99.9%important;
  }
  .el-table__header,
  .el-table__body {
    overflow: hidden;
    width: 99.9% !important;
  }
  .colsAction {
    position: absolute;
    right: 0;
    top: 0;
    .acticonBtn {
      width: 28px;
      height: 28px;
      border-radius: 4px;
      border: 1px solid #ccc;
      float: right;
      text-align: center;
      line-height: 28px;
      cursor: pointer;
      position: relative;
      &:hover {
        color: #66b1ff;
      }
    }
  }

  .sortable-drag {
    background-color: #ccc;
  }

  .filtered {
    color: red;
  }
}
.dialogLeft {
  width: 500px;
  border: 1px solid #ccc;
  padding: 10px;
  margin-right: 10px;
  border-radius: 5px;
}

#dialogRight {
  flex: 1;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  max-height: 300px;
  overflow: auto;
  .item {
    height: 35px;
    line-height: 35px;
    cursor: move;
    &:hover {
      color: #66b1ff;
    }
  }
}
</style>
